<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-button @click="addData" >新增</el-button>
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="680">
	    <el-table-column fixed prop="name" label="名称" width="200" />
	    <el-table-column fixed prop="make" label="制造商" width="180" />
	    <el-table-column prop="model" label="类型" width="180" />
	    <el-table-column prop="colour" label="颜色" width="180" />
	    <el-table-column prop="plate_number" label="车牌号" width="200" />
		<el-table-column prop="driverName" label="默认司机" width="200" />
		<el-table-column label="车辆实图" width="260">
		  <template #default="scope">
			  <img @click="exspendImg(scope.row.cover_image)" :src="scope.row.cover_image" class="avatar" />
		  </template>
		</el-table-column>
	    <el-table-column fixed="right" label="操作" width="*">
	      <template #default="scope">
	        <el-button link type="primary" size="small" @click="handleDtClick(scope.row)">详情</el-button>
			<el-button link type="primary" size="small" @click="deleteData(scope.row)">删除</el-button>
			<!-- <el-button link type="primary" size="small" @click="relateMiniCar(scope.row)">关联小程序车辆</el-button> -->
	      </template>
	    </el-table-column>
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
	<el-dialog
	    v-model="imgVisible"
	    title="预览"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<img :src="imageUrl" class="avatarScan" />  
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="imgVisible = false">关闭</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
		@close="closeDtDialog"
	    v-model="jsjDialogVisible"
	    title="编辑车辆"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<DataForm />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDtDialog">关闭</el-button>
			<el-button v-if="forbidEdit" type="primary" @click="editForm">编辑</el-button>
		    <el-button v-if="!forbidEdit" type="primary" @click="saveForm">保存</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
	    v-model="linkUserDialogVisible"
	    title="关联"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-select
			v-model="miniUser"
			filterable
			placeholder="选择车辆"
			style="width: 600px"
		>
			<el-option
			  v-for="item in miniUserDatas"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			/>
		</el-select>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="linkUserDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="savelinkAge">保存</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import DataForm from './carInfo.vue';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	import JSONbig from "json-bigint";
	const userStore = useMemberStore();
	const linkUserDialogVisible = ref(false)
	const miniUserDatas = ref([])
	const miniUser = ref('')
	const savelinkAge=async()=>{
		const response = await axios.post('/manageDriver/driver/saveLinkage', {
			userID:miniUser.value,
			driverID:billid.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '关联成功!',
				type: 'success',
			})
			linkUserDialogVisible.value = false
		}else{
			ElMessage.error('哦,关联失败!')
		}
	}
	const addData=()=>{
		billid.value = ''
		jsjDialogVisible.value = true
		forbidEdit.value = false
	}
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const searchType = ref(0);
	const key = ref('');
	const type = ref('');
	const tableData = ref([]);
	const jsjDialogVisible = ref(false);//详情
	const billid = ref('');
	const forbidEdit = ref(true);
	provide('forbidEdit', forbidEdit);
	provide('billid', billid);
	const orderForm = ref({
		name:'',
		make:'',
		model:'',
		colour:'',
		plate_number:'',
		car_number:'',
		cover_image:''
	})
	const exspendImg=(url)=>{
		imgVisible.value = true
		imageUrl.value = url;
	}
	const imageUrl = ref('')
	const imgVisible = ref(false)
	provide('orderForm', orderForm);
	onMounted(async()=>{
		const response = await axios.post('/klook/car/getList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = JSONbig.parse(response.data.data)
			total.value = parseInt(response.data.total);
		}
	})
	const fetchOrders = async () => {
		searchType.value = 0;
		const response = await axios.post('/klook/car/getList', {
		  searchVal:key.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = JSONbig.parse(response.data.data);
			total.value = parseInt(response.data.total);
		}
	};
	const handleDtClick = (e)=>{
		billid.value = e.id;
		jsjDialogVisible.value = true;
	}
	const relateMiniCar=async(e)=>{
		billid.value = e.id;
		const response = await axios.post('/api/linkage/queryUsers', {
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			const datas = response.data.datas;
			const sjOptions = [];
			datas&&datas.map(item=>{
				sjOptions.push({
					value:item.id,
					label:item.id+"/"+item.name+"/"+item.mobile,
					mobile:item.mobile
				})
			})
			miniUserDatas.value = sjOptions;
		}
		linkUserDialogVisible.value = true;
	}
	const deleteData=async(e)=>{
		const response = await axios.post('/klook/car/delCar', {
		  billid:e.id,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '删除成功!',
				type: 'success',
			})
			fetchOrders()
		}
		
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
	const closeDtDialog=()=>{
		billid.value = ''
		forbidEdit.value = true;
		jsjDialogVisible.value = false;
	}
	const editForm = ()=>{
		forbidEdit.value = false;
	}
	const saveForm = async () =>{
		const response = await axios.post('/klook/car/saveOrUpdate', {
		  billid:billid.value,
		  ...orderForm.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '信息保存成功!',
				type: 'success',
			})
			fetchOrders()
		}else{
			ElMessage.error('哦,信息保存失败!')
		}
		jsjDialogVisible.value = false;
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
	.avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatarScan{
		width: 100%;
		height: 600px;
		display: block;
	}
</style>